<ng-template #content let-modal>
  <div class="modal-body" style="width:100%;">
    <ngb-tabset>
      <ngb-tab *qmAuth="'vivo'">
        <ng-template ngbTabTitle>
          {{'Diary' | translate}}
        </ng-template>
        <ng-template ngbTabContent>
          <qm-vivo-notification (close)="close()"></qm-vivo-notification>
        </ng-template>
      </ngb-tab>
      <ngb-tab>
        <ng-template ngbTabTitle>
          {{'Whiteboard' | translate}}
        </ng-template>
        <ng-template ngbTabContent>
          <qm-whiteboard></qm-whiteboard>
        </ng-template>
      </ngb-tab>
    </ngb-tabset>
  </div>
</ng-template>



<button class="btn btn-primary new-entry-btn" (click)="open(content)" placement="right" container="body" ngbTooltip="{{ 'Create new notification' | translate }}">
  <i class="far fa-plus fa-2x"></i>
</button>
